import {IEntityNode} from "../types";
import {Feature} from "geojson";

export function createParsedFeatureNode (feature: Feature, patch: IEntityNode): Feature {
    if (patch) {
        Object.keys(patch).forEach(key => {
            const val = patch[key]
            if (val === null || typeof val === 'undefined') {
                delete patch[key];
            }
        });
    }
    const properties = {...feature.properties, ...patch};
    return {
        ...feature,
        properties
    };
}